import { Navigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const TrainingFormDetailIndex = () => {
  const { id, formId } = useParams<{ id: string; formId: string }>()
  const { navigation } = useNavigation()

  return (
    <>
      <Navigate
        replace
        to={navigation.trainings.list.details_revamp.trainingSurveyDetail.questions.fullPath({
          id: String(id),
          formId: String(formId),
        })}
      />
    </>
  )
}

export default TrainingFormDetailIndex
